import hoverFixedBtnComponet from './hoverFixedBtnComponents.vue';
const hoverFixedBtn = {};
hoverFixedBtn.install = function (Vue) {
  const HoverFixedBtnControll = Vue.extend(hoverFixedBtnComponet);
  const instance = new HoverFixedBtnControll().$mount(
    document.createElement('div')
  );
  document.body.appendChild(instance.$el);
};
export default hoverFixedBtn;
